const SEARCH_DEBOUNCE_TIME_MS = 500;
const SUGGESTIONS_NUMBER_LIMIT = 5;

export const SearchConfig = {
    debounceTime: SEARCH_DEBOUNCE_TIME_MS,
    suggestionsNumberLimit: SUGGESTIONS_NUMBER_LIMIT,
};
